import { useSuspenseQuery } from '@tanstack/react-query';
import { getCookie } from 'cookies-next';

import { AskAIQuestionListApiResponse } from '../apis';

import { clientAxios } from '@/shared/api';
import { ApiResponse } from '@/shared/types';

const useAskAIQuestionListQuery = () => {
  const anonymousNewsUserUuid = getCookie('anonymous_news_user_uuid');

  return useSuspenseQuery({
    queryKey: ['askAI', 'questions', anonymousNewsUserUuid],
    queryFn: async () => {
      const { data } = await clientAxios.get<
        ApiResponse<AskAIQuestionListApiResponse>
      >('/askAIQuestionListApi/');

      return data.data.map(({ hash_key, question_text }) => ({
        hashKey: hash_key,
        questionText: question_text,
      }));
    },
  });
};

export default useAskAIQuestionListQuery;
